import { useState, useEffect } from "react";
import { Grid, FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import FleetWebApi from "../Api/FleetWebApi";

import ParticleShortFunction from "../Particle/ParticleShortFunction";
function CompanionFunctions(props) {
  const [proxies, setProxies] = useState({ allProxies: [], recentProxies: [] });
  const [hub, setHub] = useState("");
  const [productSlug, setProductSlug] = useState(null);

  useEffect(() => {
    let isMounted = true;

    FleetWebApi.getProxies(props.coreId, "noncellular_device")
      .then((response) => {
        if (isMounted) {
          setProxies(response);
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.log(error);
        }
      });
    return () => {
      isMounted = false;
      setProxies({ allProxies: [], recentProxies: [] });
    };
  }, [props.coreId]);

  useEffect(() => {
    let isMounted = true;

    if (hub) {
      FleetWebApi.getProductSlug(hub)
        .then((response) => {
          if (isMounted) {
            setProductSlug(response);
          }
        })
        .catch((error) => {
          if (isMounted) {
            console.log(error);
          }
        });
    }
    return () => {
      isMounted = false;
      setProductSlug(null);
    };
  }, [hub]);
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12} lg={12}>
        <h1>Companion Functions</h1>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <FormControl variant="filled">
          <InputLabel htmlFor="state">Select Proxy</InputLabel>

          <Select
            value={hub}
            onChange={(e) => setHub(e.target.value)}
            disabled={proxies.recentProxies.length === 0}
            style={{ width: "300px" }}
            inputProps={{
              name: "state",
              id: "state",
            }}
          >
            {proxies.recentProxies.map((proxy, key) => (
              <MenuItem value={proxy.coreID} key={key}>
                {proxy.serialNumber}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <h3>Functions</h3>
      </Grid>
      {hub && productSlug && (
        <Grid item xs={12} md={12} lg={12}>
          <ParticleShortFunction
            name="Get Device Record"
            calls={[{ func: "Hub", args: ["get", props.coreId] }]}
            coreId={hub}
            productId={productSlug}
          />
          <ParticleShortFunction
            name="Reboot"
            calls={[{ func: "Hub", args: ["Reboot", props.coreId] }]}
            coreId={hub}
            productId={productSlug}
          />
          {props.deviceType === "Shuttie" && (
            <ParticleShortFunction
              name="Shuttie Checkin"
              calls={[{ func: "Shuttie", args: ["checkin"] }]}
              coreId={hub}
              productId={productSlug}
            />
          )}
          {props.deviceType === "Shuttie2" && (
            <ParticleShortFunction
              name="Shuttie2 Checkin"
              calls={[{ func: "Shuttie2", args: ["checkin " + props.coreId] }]}
              coreId={hub}
              productId={productSlug}
            />
          )}
        </Grid>
      )}
    </Grid>
  );
}

export default CompanionFunctions;
